define((require) => {
    "use strict";

    var Backbone                      = require("backbone"),
        ExperienceMetadata            = require("ui/experience/ExperienceMetadata"),
        GroupMetadata                 = require("ui/experience/GroupMetadata"),
        LoggedIn                      = require("shared/security/LoggedIn"),
        ExperienceCollection          = require("ui/experience/ExperienceCollection"),
        UrlUtil                       = require("shared/util/UrlUtil"),
        RestApi                       = require("shared/services/RestApi");

    /**
     * A collection of experience meta data.
     *
     * @class ExperienceMetadataCollection
     * @constructor
     *
     * @cfg {boolean} pushedOnly If true, only pushed experiences will be fetched from the server.
     * @cfg {boolean} includeMeasureData Whether to inculde the experience measure data or not.
     */
    var ExperienceMetadataCollection = Backbone.Collection.extend({

        model: function(attributes) {
            if (attributes.type && attributes.type === "ExperienceMetadata") {
                return new ExperienceMetadata(attributes);
            }

            return new GroupMetadata(attributes);
        },

        options: null,

        initialize: function(attributes, options) {
            this.options = options;
        },

        url: function() {
            var baseURL = RestApi.pathToCollectionOnResource(
                RestApi.Collections.COMPANIES, LoggedIn.companyId(),
                RestApi.Collections.EXPERIENCES_META
            );

            // Append options if any
            return this.options ? UrlUtil.appendParamObject(baseURL, this.options) : baseURL;
        },

        experiences: function() {
            var filteredExperienceData = this.filter((model) => {
                return model instanceof ExperienceMetadata;
            });

            return new ExperienceCollection(filteredExperienceData.map((metadata) => {
                return metadata.get("model"); // already tagged as meta data by the API!
            }));
        },

        fromExperience: function(experienceModel) {
            return this.find((metadata) => {
                // Might be a clone? :(
                var experience = metadata.get("model");

                return experience && experience.get("id") === experienceModel.get("id");
            });
        }

    }, {

        experiences: function(options) {
            return new ExperienceMetadataCollection([], options)
                .fetch()
                .then((collection) => {
                    return collection.experiences();
                });
        }

    });

    return ExperienceMetadataCollection;
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/ExperienceMetadataCollection.js